import React, { useCallback, memo } from 'react';
import {Alert, Col} from "reactstrap";
import { Link, useNavigate, useLocation } from 'react-router-dom'
import CoverAuth from "./CoverAuth";
import SignUpForm from "./SignUpForm";
import {useRedux} from "../../../hooks";
import SignUpSuccess from "../../../components/SignUpSuccess";

import '../../../i18/config';
import {useTranslation} from "react-i18next";
import CoverLangSwitch from "../../../components/CoverLangSwitch";
import * as route from "../../../api/routes";
import {ConfirmCodeType} from "../../../redux/types";
import {onConfirmEmail, onResendConfirmationEmail} from "../../../redux/Main/User/actions";
import ConfirmationBlock from "../../../components/Auth/ConfirmationBlock";
import SignUpFormPasskey from "./SignUpFormPasskey";

const CoverSignUp = memo(() => {
    const { t } = useTranslation(['auth']);
    const navigate = useNavigate();
    const { dispatch, useAppSelector } = useRedux();
    const location = useLocation();

    const {
        mainUser,
        isEmailConfirmed,
        confirmationToken,
    } = useAppSelector(state => ({
        mainUser: state.MainUser,
        isEmailConfirmed: state.MainUser.isEmailConfirmed,
        confirmationToken: state.MainUser.confirmation.token,
    }));

    const handleCancel = useCallback(() => {
        navigate(route.MAIN_AUTH_LOGIN);
    }, [navigate]);

    const handleSubmit = useCallback((verificationCode: string) => {
        const confirmData: ConfirmCodeType = {
            confirmationToken: mainUser.confirmation.token,
            code: verificationCode
        };
        dispatch(onConfirmEmail(confirmData));
    }, [dispatch, mainUser.confirmation.token]);

    const onResendConfirmation = useCallback(() => {
        dispatch(onResendConfirmationEmail());
    }, [dispatch]);

    return (
        <CoverAuth title={t('auth:signUp')+' | Marketcells.io - digital marketing platform'}>
            {!isEmailConfirmed ? (
                <Col lg={6}>
                    <CoverLangSwitch/>
                    <div className="p-lg-5 p-4">
                        <div>
                            <h5 className="text-primary">{t('auth:registerAccount')}</h5>
                            <p className="text-muted">{t('auth:getYourFreeAccount')}</p>
                        </div>

                        {confirmationToken && confirmationToken.length > 0 ? (
                            <ConfirmationBlock
                                timerDuration={30}
                                handleSubmit={handleSubmit}
                                onResendConfirmation={onResendConfirmation}
                                handleCancel={handleCancel}
                                error={mainUser.error}
                            />
                        ) : (
                            <>
                                <Alert className="alert-borderless alert-warning text-center mb-2" role="alert">
                                    {t('auth:resetPasswordMessage1')}!
                                </Alert>
                                <div className="mt-4">
                                    {location.pathname === route.MAIN_AUTH_SIGN_UP_PASSKEY ?
                                        <SignUpFormPasskey/>
                                        :
                                        <SignUpForm/>
                                    }
                                </div>
                            </>
                        )}

                        <div className="mt-5 text-center">
                            <p className="mb-0">{t('auth:alreadyHaveAccount')}? <Link to={route.MAIN_AUTH_LOGIN}
                                                                                   className="fw-bold text-primary text-decoration-underline">{t('auth:signIn')}</Link>
                            </p>
                        </div>
                    </div>
                </Col>
            ) : (
                <SignUpSuccess/>
            )}
        </CoverAuth>
    );
});

export default CoverSignUp;